var React = require('react');

function PlusSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 6C10 6 10 10.4853 10 14M14 10C14 10 9.90524 10 6 10","stroke":"#22202F","strokeLinecap":"square","strokeLinejoin":"round"}));
}

PlusSmall.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = PlusSmall;

PlusSmall.default = PlusSmall;
